import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import { CKEditor } from "@ckeditor/ckeditor5-react";
//import Context from "@ckeditor/ckeditor5-core/src/context";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
//-----------------------------------------------------------------------------------------
import CurrentMaterialCost from "src/components/common/currentMaterialCost";
import UserInfo from "src/components/common/userInfo";
import FileSystem from "src/components/common/fileSystem";
import { useMyStore } from "src/components/main/mainStore";
import {
    numberReducer, onlyUnique , MyFormData, myAxios,
    defaultEmptyDateTime, mimeTypeMap, simpleStatusColorCode, arrayReducer,
    scroll, fileSystemSchemaForProjects, testerEmails,
    getTimeStamp,
    isDevMode,
    projectAdmins
} from "src/components/common/functions";
import WorkInstructions from "./workInstruction/workInstructions";
//-----------------------------------------------------------------------------------------
export default function ProjectDetail({
    userList, 
    setProjects, 
    projects, 
    project, 
    updatePopUp, 
    generateReport, 
    history, 
    tabPath
}){
    const user = useMyStore(state => state.user);
    const purchases = useMyStore(state => state.billingPurchases);
    const workLogs = useMyStore(state => state.billingWorkLogs);
    const [updateDateTime, setUpdateDateTime] = useState({
        "Purchases": purchases.updatedAt === null?getTimeStamp():purchases.updatedAt, 
        "Work Logs": workLogs.updatedAt === null?getTimeStamp():workLogs.updatedAt, 
    });
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const archiveProject = async() => {
        if(window.confirm(`Are you sure you want to archive ${project.projectName}`)){
            const formData = new MyFormData();
            formData.append("projectHashKey", project.projectHashKey);
            formData.append("calendarId", project.calendarId);
            formData.append("projectFolderId", project.projectFolderId);
            formData.append("projectName", project.projectName);
            formData.append("projectManagerEmail", project.projectManagerEmail);
            formData.append("opportunityHashKey", project.opportunityHashKey === null?"":project.opportunityHashKey);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("projects/archiveProject.php", formData);
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setProjects(projects.filter(localProject => localProject.projectHashKey !== project.projectHashKey));
            history.replace(tabPath);
            scroll(null);
        }
    }
    const restoreProject = async() => {
        if(window.confirm(`Are you sure you want to restore ${project.projectName}`)){
            const formData = new MyFormData();
            formData.append("projectHashKey", project.projectHashKey);
            formData.append("calendarId", project.calendarId);
            formData.append("projectFolderId", project.projectFolderId);
            formData.append("projectName", project.projectName);
            formData.append("projectManagerEmail", project.projectManagerEmail);
            formData.append("opportunityHashKey", project.opportunityHashKey === null?"":project.opportunityHashKey);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("projects/restoreProject.php", formData);
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setProjects(projects.filter(localProject => localProject.projectHashKey !== project.projectHashKey));
            history.replace(tabPath);
            scroll(null);
        }
    }
    //-----------------------------------------------------------------------------------------
    const [reports, setReports] = useState([]);
    const [projectDetailRenderSwitch, setProjectDetailRenderSwitch] = useState(false);
    const [totalHours, setTotalHours] = useState(null);
    const [potholing, setPotholing] = useState({
        pothole: "Loading",
        manhole: "Loading",
        electric: "Loading",
    });
    const [sc, setSc] = useState({
        scanningCoring: "Loading",
        scanning: "Loading",
        coring: "Loading"
    });
    const [locating, setLocating] = useState({
        "White (ft)": "Loading",
        "Pink (ft)": "Loading",
        "Red (ft)": "Loading",
        "Yellow (ft)": "Loading",
        "Orange (ft)": "Loading",
        "Blue (ft)": "Loading",
        "Purple (ft)": "Loading",
        "Green (ft)": "Loading",
        "Total (ft)": "Loading"
    });
    //-----------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const getData = async () => {
            if(isDevMode) console.log("useEffect");
            const formData = new MyFormData();
            formData.append("projectHashKey", project.projectHashKey);
            if(project.pipeline === "GPR Concrete Scanning and Coring Project"){
                //---------------------------------------------------------------------
                setShowLoader(true);
                const resDataSheets = await myAxios("projects/readProjectSC.php",  formData);
                if(!isMounted){ 
                    setShowLoader(false);
                    return;
                }
                if(!resDataSheets){
                    setShowLoader(false);
                    return;
                }
                //---------------------------------------------------------------------
                const dataSheets = resDataSheets.data;
                if(dataSheets.length){
                    setSc({
                        scanningCoring: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Scaning & Coring").length,
                        scanning: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Scanning").length,
                        coring: dataSheets.filter(d => d.laborCategory === "GPR & Concrete Coring").length
                    });
                }else{
                    setSc({
                        scanningCoring: 0,
                        scanning: 0,
                        coring: 0
                    });
                }
            }else if(
                project.pipeline === "Potholing Project" || 
                project.pipeline === "Locating Project"
            ){
                //---------------------------------------------------------------------
                const resDataSheets = await myAxios("projects/readProjectDataSheets.php",  formData);
                if(!isMounted){ 
                    setShowLoader(false);
                    return;
                }
                if(!resDataSheets){
                    setShowLoader(false);
                    return;
                }
                //---------------------------------------------------------------------
                const dataSheets = resDataSheets.data;
                const forms = dataSheets.map(d => JSON.parse(d.forms)).reduce(arrayReducer, []);
                const defaultLocating = {
                    "White (ft)": "0",
                    "Pink (ft)": "0",
                    "Red (ft)": "0",
                    "Yellow (ft)": "0",
                    "Orange (ft)": "0",
                    "Blue (ft)": "0",
                    "Purple (ft)": "0",
                    "Green (ft)": "0",
                    "Total (ft)": "0"
                };
                const reduceFunc = (a, b) => {
                    const obj = {};
                    for(let key in defaultLocating){
                        obj[key] = window.Number.parseFloat(a[key] || "0") + window.Number.parseFloat(b[key] || "0");
                    }
                    obj["Total (ft)"] = Object.values(obj).reduce(numberReducer, 0);
                    return obj;
                }
                const curLocating = forms.filter(d => d.form === "Locating Form").map(d => JSON.parse(d.content || "{}")).reduce((a, b) => reduceFunc(a, b), defaultLocating);
                setLocating(curLocating);
                if(dataSheets.length){
                    setPotholing({
                        pothole: dataSheets.map(d => JSON.parse(d.potholingForm).length).reduce(numberReducer, 0),
                        manhole: forms.filter(d => d.form === "Manhole Form").length,
                        electric: forms.filter(d => d.form === "Electric Pothole Form").length
                    });
                }else{
                    setPotholing({
                        pothole: 0,
                        manhole: 0,
                        electric: 0
                    });
                }
            }
            //---------------------------------------------------------------------
            const resReports = await myAxios("projects/readReports.php", formData);
            if(!isMounted){ 
                setShowLoader(false);
                return;
            }
            if(!resReports){
                setShowLoader(false);
                return;
            }
            setReports(resReports.data === ""?[]:resReports.data);
            //---------------------------------------------------------------------
            const resHours = await myAxios("projects/readTotalHours.php", formData);
            if(!isMounted){ 
                setShowLoader(false);
                return;
            }
            if(!resHours){
                setShowLoader(false);
                return;
            }
            setTotalHours(resHours.data === ""?[]:resHours.data);
        }
        getData();
        return () => {
            isMounted = false;
            setShowLoader(false);
        }
    },[project.pipeline, project.projectHashKey, projectDetailRenderSwitch])
    //-----------------------------------------------------------------------------------------
    return(
        <div className = "border rounded">
            <div className = "cssSeperateWhenWide pl-3">
                <div className = "flex-grow-1 maxWidth-50 mr-3">
                    <table className = "table table-fixed">
                        <tbody className = "noTableTopBorder">
                            <tr>
                                <th>Report Needed:</th>
                                <td>
                                    {project.reportNeeded}   
                                </td>
                            </tr>
                            {project.usaTicketNumber?
                            <tr>
                                <th>USA Ticket Number:</th>
                                <td>
                                    {project.usaTicketNumber}   
                                </td>
                            </tr>
                            :<></>}
                            <tr>
                                <th>Job Site Location:</th>
                                <td>
                                    {project.location}
                                </td>
                            </tr>
                            <tr>
                                <th>Location of Nearest Medical Facility:</th>
                                <td>
                                    {project.nearestMedicalFacility}
                                </td>
                            </tr>
                            <tr>
                                <th>Opportunity Name:</th>
                                <td>
                                    <Link to = {`/Opportunities/${project.opportunityHashKey}`}>{project.opportunityName}</Link>
                                </td>
                            </tr>
                            <tr>
                                <th>Requestor:</th>
                                <td>
                                    <Link to = {`/Contacts/${project.requestorHashKey}`}>{project.requestor}</Link>
                                </td>
                            </tr>
                            <tr>
                                <th>Client PO:</th>
                                <td>
                                    {project.clientPONumber}
                                </td>
                            </tr>
                            <tr>
                                <th>Region:</th>
                                <td>{project.region}</td>
                            </tr>
                            <tr>
                                <th>Creator:</th>
                                <td>
                                    <UserInfo name = {project.creator} email = {project.projectCreatorEmail}/>
                                    <span className = "ml-3">{project.projectCreationDate}</span>
                                </td>
                            </tr>
                            {project.projectUpdaterEmail?
                            <tr>
                                <th>Updater:</th>
                                <td>
                                    <UserInfo name = {project.updater} email = {project.projectUpdaterEmail}/>
                                    <span className = "ml-3">{project.projectDateUpdated}</span>
                                </td>
                            </tr>
                            :<></>}
                            {project.statusChangerEmail?
                            <tr>
                                <th>Stage Changer:</th>
                                <td>
                                    <UserInfo
                                        name = {project.statusChanger}
                                        email = {project.statusChangerEmail}
                                    />
                                    <span className = "ml-3">{project.statusChangeDateTime}</span>
                                </td>
                            </tr>
                            :<></>}
                            <tr>
                                <th>Description:</th>
                                <td>
                                    <div dangerouslySetInnerHTML = {{__html: project.projectDescription}}/>
                                </td>
                            </tr>
                            <tr>
                                <th>Notes:</th>
                                <td>
                                    <div dangerouslySetInnerHTML = {{__html: project.projectNotes}}/>
                                </td>
                            </tr>
                            <tr>
                                <th>Accurate Time On Job Tab:</th>
                                <td>
                                    {project.accurateTime === "on"?"Yes":"No"}
                                </td>
                            </tr>
                            <tr>
                                <th>Client Signature Required:</th>
                                <td>
                                    {project.clientSignatureRequired === "on"?"Yes":"No"}
                                </td>
                            </tr>
                            <tr>
                                <th>Send To Client:</th>
                                <td>
                                    {project.sendToClient === "on"?"Yes":"No"}
                                </td>
                            </tr>
                            {project.pipeline === "Potholing Project"?
                            <>
                            <tr>
                                <th>Number of Potholes:</th>
                                <td>
                                    {potholing.pothole}
                                </td>
                            </tr>
                            <tr>
                                <th>Number of Manholes:</th>
                                <td>
                                    {potholing.manhole}
                                </td>
                            </tr>
                            <tr>
                                <th>Number of Electric Potholes:</th>
                                <td>
                                    {potholing.electric}
                                </td>
                            </tr>
                            </>:<></>}
                            {project.pipeline === "GPR Concrete Scanning and Coring Project"?
                            <>
                            <tr>
                                <th>Number of Scanning and Coring:</th>
                                <td>
                                    {sc.scanningCoring}
                                </td>
                            </tr>
                            <tr>
                                <th>Number of Coring:</th>
                                <td>
                                    {sc.coring}
                                </td>
                            </tr>
                            <tr>
                                <th>Number of Scanning:</th>
                                <td>
                                    {sc.scanning}
                                </td>
                            </tr>
                            </>:<></>}
                            {project.cctv?
                            <>
                            <tr>
                                <th>Completed Linear Footage:</th>
                                <td>
                                    {JSON.parse(project.cctv).linear}
                                </td>
                            </tr>
                            <tr>
                                <th>Completed Lateral Footage:</th>
                                <td>
                                    {JSON.parse(project.cctv).lateral}
                                </td>
                            </tr>
                            <tr>
                                <th>Video Required:</th>
                                <td>
                                    {JSON.parse(project.cctv).videoReq?"Yes":"No"}
                                </td>
                            </tr>
                            {JSON.parse(project.cctv).videoReq?
                            <tr>
                                <th>Video Captured:</th>
                                <td>
                                    {JSON.parse(project.cctv).videoCap?"Yes":"No"}
                                </td>
                            </tr>
                            :<></>}
                            <tr>
                                <th>Marke and Locate:</th>
                                <td>
                                    {JSON.parse(project.cctv).ml?"Yes":"No"}
                                </td>
                            </tr>
                            {JSON.parse(project.cctv).ml?<>
                            <tr>
                                <th>Sewer:</th>
                                <td>
                                    {JSON.parse(project.cctv).sewer}
                                </td>
                            </tr>
                            <tr>
                                <th>Storm:</th>
                                <td>
                                    {JSON.parse(project.cctv).storm}
                                </td>
                            </tr>
                            </>
                            :<></>}
                            </>:<></>}
                            {project.pipeline === "Locating Project"?
                            <>
                            {Object.entries(locating).map((entry, entryIndex) => <tr key = {entryIndex}>
                                <th>{entry[0]}:</th>
                                <td>
                                    {entry[1]}
                                </td>
                            </tr>)}
                            </>:<></>}
                            {project.pipeline === "Potholing Project" && false?
                            <tr>
                                <th>Report:</th>
                                <td>
                                    {project.pipeline === "Potholing Project" && project.reportLink?
                                    <div>
                                        <a href = {project.reportLink} target = "_blank" rel = "noreferrer">
                                            {project.reportCreationDate}
                                        </a>
                                        <span className = "btn btn-primary mx-4" onClick = {async () => {
                                            const formData = new MyFormData();
                                            formData.append("fileId[]", project.KML);
                                            formData.append("fileName[]", `${project.projectName}.kml`);
                                            //---------------------------------------------------------------------
                                            setShowLoader(true);
                                            const res = await myAxios("common/getAttachment.php", formData, "blob");
                                            setShowLoader(false);
                                            if(!res) return;
                                            //---------------------------------------------------------------------
                                            const file = new Blob([res.data], {type: mimeTypeMap.kml});
                                            saveAs(file, `${project.projectName}.kml`);
                                        }}>KML</span>
                                    </div>
                                    :<></>}
                                </td>
                            </tr>
                            :<></>}
                        </tbody>
                    </table>
                </div>
                <div className = "flex-grow-1 maxWidth-50 mr-3">
                    <table className = "table table-fixed">
                        <tbody className = "noTableTopBorder">
                            <tr>
                                <th>
                                    Estimate Budget:
                                </th>
                                <td>
                                    {project.budget}
                                </td>
                            </tr>
                            {project.budgets && JSON.parse(project.budgets)[0].amount !== ""?<>
                            <tr>
                                <th colSpan = {3} className = "text-center">
                                    Budget Scope
                                </th>
                            </tr>
                            <tr>
                                <th>Amount ($)</th>
                                <th>Start</th>
                                <th>End</th>
                            </tr>
                            {JSON.parse(project.budgets).map((bud, budIndex, buds) => 
                                <tr key = {budIndex}>
                                    <td>{bud.amount}</td>
                                    <td>{budIndex === 0?bud.start:buds[budIndex - 1].end}</td>
                                    <td>{bud.end}</td>
                                </tr>
                            )}
                            </>:<></>}
                            <tr><th>Billing Type:</th><td>{project.billingType}</td>{project.billingType === "T & M"?<td/>:<></>}</tr>
                            {project.billingType === "Day Rate"?
                            <>
                            <tr>
                                <th>Days:</th>
                                <td>
                                    <div className = "progress">
                                        <div className = "progress-bar progress-bar-striped" role = "progressbar" style = {{
                                            width: `${(totalHours !== null?
                                                Math.round(totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => d.travelStartTime.substring(0, 10))
                                                .filter(onlyUnique).length * 100) / 100:0)
                                            / project.days * 100}%`
                                            }}>
                                        </div>
                                    </div>
                                    <div className = "text-center m-1">
                                        {(totalHours !== null?
                                        Math.round(totalHours.filter(t => t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => d.travelStartTime.substring(0, 10))
                                        .filter(onlyUnique).length * 100) / 100:0)}/{project.days}
                                    </div>
                                </td>
                            </tr>
                            </>:<></>}
                        </tbody>
                    </table>
                    <div>
                        {project.billingType === "T & M"?
                        <>
                        <details className = "mt-2">
                            <summary>Labor Hours:</summary>
                            <div>
                                {totalHours !== null && totalHours.map(t => t.laborCategory).filter(onlyUnique).sort().map((ddd, dddk) => 
                                <div key = {dddk} className = "mb-3 mt-3">
                                    <div className = "text-center m-1 font-weight-bold">{ddd}</div>
                                    <div className = "progress">
                                        <div className = "progress-bar bg-success progress-bar-striped" 
                                            role = "progressbar" style = {{
                                            width: `${(totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime)
                                            .map(d => {
                                                const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                            }).length?
                                            Math.round(totalHours.filter(t => t.billed === "Yes" && t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime)
                                            .map(d => {
                                                const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                            })
                                            .reduce(numberReducer, 0) * 100) / 100:0)
                                            / project.laborHours * 100}%`}}
                                        />
                                        <div className = "progress-bar progress-bar-striped" 
                                            role = "progressbar" style = {{
                                            width: `${
                                                (
                                                (totalHours.filter(t => t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                }).length?
                                                    Math.round(totalHours.filter(t => t.laborCategory === ddd &&  t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                        const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                        const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                        return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                    })
                                                .reduce(numberReducer, 0) * 100) / 100:0) -
                                                (totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                }).length?
                                                Math.round(totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                })
                                                .reduce(numberReducer, 0) * 100) / 100:0)
                                                )
                                            / project.laborHours * 100}%`}}
                                        />
                                    </div>
                                    <div className = "text-center m-1">
                                        <div>
                                            Billed:&nbsp;
                                            {
                                                (totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                }).length?
                                                Math.round(totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                })
                                                .reduce(numberReducer, 0) * 100) / 100:0)
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            Not Billed:&nbsp;
                                            {
                                                (totalHours.filter(t => t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                }).length?
                                                Math.round(totalHours.filter(t => t.laborCategory === ddd && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                })
                                                .reduce(numberReducer, 0) * 100) / 100
                                                :0) 
                                                -
                                                (totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                }).length?
                                                Math.round(totalHours.filter(t => t.laborCategory === ddd && t.billed === "Yes" && t.jobTagSubmitTime !== defaultEmptyDateTime).map(d => {
                                                    const travelEndTime = d.travelEndTime ? d.travelEndTime.replace(/-/g, "/") : null;
                                                    const travelStartTime = d.travelStartTime ? d.travelStartTime.replace(/-/g, "/") : null;
                                                    return (new Date(travelEndTime) - new Date(travelStartTime)) / 3600000;
                                                })
                                                .reduce(numberReducer, 0) * 100) / 100:0)
                                            }
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            Estimate:&nbsp;
                                            {project.laborHours}
                                        </div>
                                    </div>
                                </div>)}
                            </div>
                        </details>
                        <details className = "mt-2">
                            <summary>Material Cost:</summary>
                            <div>{project.materialCost}</div>
                        </details>
                        </>:<></>}
                        <CurrentMaterialCost
                            updateDateTime = {updateDateTime}
                            projectHashKey = {project.projectHashKey}
                            projectName = {project.projectName}
                            className = {"mt-2"}
                        />
                        <details open className = "mt-2">
                            <summary>Files</summary>
                            <FileSystem
                                className = "mt-2"
                                fileSystem = {fileSystemSchemaForProjects}
                                item = {project}
                                setItems = {setProjects} 
                                items = {projects}
                                sqlTable = "projects"
                                itemLabel = "project"
                                hashKeyLabel = "projectHashKey"
                                filesKey = "projectFiles"
                                readOnly = {user.projects === "readOnly"}
                            />
                            <div>
                            {project.reportNeeded?
                            <div className = "my-4">
                                <h4>Reports Status<span className = "ml-2 badge badge-primary">{reports.length}</span></h4>
                                {reports.map((report, reportIndex) =>  
                                <li key = {reportIndex} className = "my-2">
                                    <UserInfo name = {report.reportTech} email = {report.reportTechEmail}/>
                                    <span className = "ml-2">{report.startDate} ~ {report.endDate}</span>
                                    {report.pdfId?
                                    <a
                                        className = "mx-2 btn btn-primary"
                                        href = {`https://drive.google.com/file/d/${report.pdfId}/view?usp=drivesdk`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        View
                                    </a>
                                    :<></>}
                                    <Link
                                        className = "mx-2 btn btn-info"
                                        to = {`/Reports/${report.reportHashKey}`}
                                    >
                                        Detail
                                    </Link>
                                    <span className = "ml-2" style = {{color: simpleStatusColorCode[report.status]}}>{report.status}</span>
                                </li>)}
                            </div>
                            :<></>}
                            </div>
                        </details>
                    </div>
                    {user.projects !== "readOnly"?
                    <div className = "float-right">
                        <div>
                            {project.pipeline === "Potholing Project" && false?
                            <button type = "button" className = "btn btn-info my-3 mx-2" onClick = {generateReport}>Generate Report File</button>
                            :<></>}
                            <button type = "button" className = "btn btn-success my-3 mx-2" onClick = {updatePopUp}>Edit</button>
                            {projectAdmins.includes(user.email) && project.stage !== "Archived"?<button type = "button" className = "btn btn-danger my-3 mx-2" onClick = {archiveProject}>Archive</button>:<></>}
                            {projectAdmins.includes(user.email) && project.stage == "Archived"?<button type = "button" className = "btn btn-warning my-3 mx-2" onClick = {restoreProject}>Restore</button>:<></>}
                        </div>
                    </div>
                    :<></>}
                </div>
            </div>
            {totalHours !== null?
            <WorkInstructions
                userList = {userList}
                history = {history}
                projects = {projects}
                project = {project}
                totalHours = {totalHours}
                setProjectDetailRenderSwitch = {setProjectDetailRenderSwitch}
            />
            :<></>}
        </div>
    )
}

        // //--------------------------------------------------------
        // const data1 = [];
        // //--------------------------------------------------------
        // const data2 = [];
        // if(formType === "Potholing Form"){
        //     data2.push(...res.data
        //     .map((project => ({
        //         ...project, 
        //         laborName: project.laborName.replace(/ {2}/g, " "),
        //         forms: JSON.parse(project.potholingForm)
        //     })))
        //     .map(project => project.forms.map(f => ({...project, ...f, formSubmitTime: f.potholingFormSubmitTime, form: "Potholing Form"})))
        //     .reduce(arrayReducer, []));
        // }else if(formType){
        //     data1.push(...res.data
        //     .map((project => ({
        //         ...project, 
        //         laborName: project.laborName.replace(/ {2}/g, " "),
        //         forms: JSON.parse(project.forms)
        //     })))
        //     .map(project => project.forms.map(f => ({...project, ...f})))
        //     .reduce(arrayReducer, []));
        // }else{
        //     data2.push(...res.data
        //     .map((project => ({
        //         ...project, 
        //         laborName: project.laborName.replace(/ {2}/g, " "),
        //         forms: JSON.parse(project.potholingForm)
        //     })))
        //     .map(project => project.forms.map(f => ({...project, ...f, formSubmitTime: f.potholingFormSubmitTime, form: "Potholing Form"})))
        //     .reduce(arrayReducer, []));
        //     data1.push(...res.data
        //     .map((project => ({
        //         ...project, 
        //         laborName: project.laborName.replace(/ {2}/g, " "),
        //         forms: JSON.parse(project.forms)
        //     })))
        //     .map(project => project.forms.map(f => ({...project, ...f})))
        //     .reduce(arrayReducer, []));
        // }